module.exports = __webpack_public_path__ + "img/platinumRiver@2x.10f7424.webp";